import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config'; // Importing configuration settings

/**
 * Class representing the filter view for withdrawal requests.
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get the screen size configuration
        const center_left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            options: [
                                // Options for the dropdown
                                {
                                    id: '',
                                    value: _('Todos'), // Localized option
                                },
                                {
                                    id: 'A',
                                    value: _('Activo'), // Localized option
                                },
                                {
                                    id: 'I',
                                    value: _('Inactivo'), // Localized option
                                },
                                {
                                    id: 'R',
                                    value: _('Rechazado'), // Localized option
                                },
                                {
                                    id: 'P',
                                    value: _('Pendiente'), // Localized option
                                },
                                {
                                    id: 'E',
                                    value: _('Eliminado'), // Localized option
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for IP address
                            name: 'Ip',
                            label: "<span class='icon-ip'></span>" + _('Dirección IP'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '), // Localized placeholder
                        },
                        {
                            view: 'text', // Text input for minimum value
                            name: 'ValueMinimum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Mínimo'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Valor Mínimo'), // Localized placeholder
                        },
                        {
                            view: 'text', // Text input for maximum value
                            name: 'ValueMaximum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Máximo'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Valor Máximo'), // Localized placeholder
                        },
                    ],
                },
            ],
        };
        const center_right = {
            margin: 5,
            rows: [], // Placeholder for future content
        };
        const upper_section = {
            css: 'father-container',
            height: screen == 'small' ? 450 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [center_left], // Left section of the form
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Localized button text
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Localized button text
                    hotkey: 'enter', // Shortcut key for submission
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the accordion section
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [accordion_section], // Accordion section as the main content
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Placeholder for future responsive behavior
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
